import { ColorEnum } from '@/constants/color'
import Switch from '@/features/ui/inputs/components/Switch'
import Typography from '@/features/ui/typography'
import { ComponentType, FC } from 'react'
import { Pressable, StyleSheet, View } from 'react-native'
import { SvgProps } from 'react-native-svg'

export interface ToggleItemProps {
    checked: boolean
    onChange: (checked: boolean) => void
    disabled?: boolean
    label?: string
    description?: string
    LabelIcon?: ComponentType<SvgProps>
}

const ToggleItem: FC<ToggleItemProps> = ({
    label,
    LabelIcon,
    checked,
    disabled = false,
    description,
    onChange,
}) => {
    const handleLabelPress = () => {
        onChange(!checked)
    }

    return (
        <View style={styles.container}>
            <Pressable style={styles.textContainer} onPress={handleLabelPress} disabled={disabled}>
                {label && (
                    <View style={styles.label}>
                        {LabelIcon && <LabelIcon />}
                        <Typography.Heading variant="h5">{label}</Typography.Heading>
                    </View>
                )}
                {description && (
                    <Typography.Description font="regular" style={{ color: ColorEnum.GRAY_600 }}>
                        {description}
                    </Typography.Description>
                )}
            </Pressable>
            <Switch checked={checked} onChange={onChange} disabled={disabled} />
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        paddingVertical: 8,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    label: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
    },
    textContainer: {
        gap: 8,
        flex: 1,
    },
})
export default ToggleItem
